import { render, staticRenderFns } from "./TourGuideModule.vue?vue&type=template&id=3381d56e&slot-scope=tour"
import script from "./TourGuideModule.vue?vue&type=script&lang=js"
export * from "./TourGuideModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports